import { render, staticRenderFns } from "./_staffSection.vue?vue&type=template&id=2b40ce10&scoped=true&"
import script from "./_staffSection.vue?vue&type=script&lang=js&"
export * from "./_staffSection.vue?vue&type=script&lang=js&"
import style0 from "./_staffSection.vue?vue&type=style&index=0&id=2b40ce10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40ce10",
  null
  
)

export default component.exports